import { render } from "./RichEditor.vue?vue&type=template&id=21f030ff&ts=true"
import script from "./RichEditor.vue?vue&type=script&lang=ts"
export * from "./RichEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__